
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy-property",
      function () {
        return require("private-next-pages/buy-property.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy-property"])
      });
    }
  